import React from 'react';
import * as Styles from '../../../../SharedModules/StyleConstant/StyleConstant';
import {
  textMatcher,
  textMatcherWith2Decimal,
  cellRenderer,
  amountComparator,
} from '../../../../SharedModules/utilities/utilities';

const fourDecimalRenderer = (params, a) => {
  const { value } = params;
  const { isTextColorRed } = params.colDef;
  const { printPrefixValue } = params.colDef;
  const { printPostfixValue } = params.colDef;
  if (value === '') return '';
  if (value < 0) {
    return (
      <span
        style={{
          color: isTextColorRed ? '#cc0000 ' : '',
        }}
      >
        {`(${printPrefixValue ? `${printPrefixValue} ` : ''}${parseFloat(value)
          .toLocaleString('en-US', {
            minimumFractionDigits: 4,
            maximumFractionDigits: 4,
          })
          .substring(1)})` + `${printPostfixValue || ''}`}
      </span>
    );
  }
  if (value > -1) {
    return (
      <span>
        {`${
          (printPrefixValue ? `${printPrefixValue} ` : '') +
          parseFloat(value).toLocaleString('en-US', {
            minimumFractionDigits: 4,
            maximumFractionDigits: 4,
          })
        }${printPostfixValue || ''}`}
      </span>
    );
  }
  return params.value || '';
};

const comparatorQtr = (a, b) => {
  const splittedQtrA = a?.split('Q');
  const splittedQtrB = b?.split('Q');
  return splittedQtrA[1] - splittedQtrB[1] || splittedQtrA[0] - splittedQtrB[0];
};

export const AllManufacturer = [
  {
    headerName: 'Manufacturer ID',
    field: 'mfgId',
    editable: false,
    suppressMenu: false,
    sort: 'asc',
    sortable: true,
    minWidth: Styles.Width_150,
    cellRenderer: 'GenericCodeTextBox',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Manufacturer Name',
    field: 'mfgName',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_150,
    cellRenderer: 'GenericCodeTextBox',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const ResultTableHead = [
  {
    headerName: 'Quarter',
    field: 'qtr',
    editable: false,
    suppressMenu: false,
    sortable: true,
    sort: 'asc',
    minWidth: Styles.Width_150,
    comparator: comparatorQtr,
    cellRenderer: 'GenericCodeTextBox',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Invoice Status',
    field: 'invoiceStatusCd',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_158,
    cellClass: 'frr-ellipsis-text',
    cellRenderer: 'ToolTipRender',
    columnSpan: 2,
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },

  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Amount Invoiced',
    field: 'totCurrQtrAmt',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_150,
    isTextColorRed: true,
    printPrefixValue: '$',
    cellRenderer,
        comparator: amountComparator,
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      textMatcher: textMatcherWith2Decimal,
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Interest Paid',
    field: 'ccInterest',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_150,
    isTextColorRed: true,
    printPrefixValue: '$',
    cellRenderer,
          comparator: amountComparator,
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textMatcher: textMatcherWith2Decimal,
    },
  },
  {
    headerName: 'Principal Paid',
    field: 'ccPrincipal',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_150,
    isTextColorRed: true,
    printPrefixValue: '$',
    cellRenderer,
          comparator: amountComparator,
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textMatcher: textMatcherWith2Decimal,
    },
  },
  {
    headerName: 'Adjustments',
    field: 'adjustments',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_158,
    isTextColorRed: true,
    printPrefixValue: '$',
    cellRenderer,
          comparator: amountComparator,
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textMatcher: textMatcherWith2Decimal,
    },
  },
  {
    headerName: 'Amount Disputed',
    field: 'disputedAmount',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_135,
    isTextColorRed: true,
    printPrefixValue: '$',
    cellRenderer,
          comparator: amountComparator,
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textMatcher: textMatcherWith2Decimal,
    },
    excelAlignment: 'right',
  },
  {
    headerName: 'Unit Change',
    field: 'ccUnitChange',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_135,
    printPrefixValue: '$',
    excelAlignment: 'right',
    cellRenderer,
    comparator: amountComparator,
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      textMatcher,
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    isTextColorRed: true,
  },
  {
    headerName: 'Amount Owed',
    field: 'ccAmountOwed',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_150,
    isTextColorRed: true,
    printPrefixValue: '$',
    cellRenderer,
          comparator: amountComparator,
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      textMatcher: textMatcherWith2Decimal,
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
